module.exports = __webpack_public_path__ + "static/media/ddawn.7244fcc0.jpeg";